import { useState, useEffect } from "react";
import { getUserById } from "../service";

const useFetchUsers = (userIds: string[]) => {
  const [users, setUsers] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const userDetails = await Promise.all(
        userIds.map(async (userId) => {
          const response = await getUserById(userId);
          return response.data;
        })
      );
      setUsers(userDetails);
    } catch (error) {
      console.error("Lỗi khi lấy danh sách người dùng:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userIds.length > 0) {
      fetchUsers();
    } else {
      setUsers([]);
      setLoading(false);
    }
  }, [userIds]);

  return { users, loading, refetchUsers: fetchUsers };
};

export default useFetchUsers;
